import React, { Component } from 'react'
import Step1 from './step1'
import Step2 from './step2'
import Sucesso from './sucesso'
import { connect } from 'react-redux'
import { buyToken } from '../../redux-flow/actions/wallet_token'
import { getInfoLocalStorage } from '../../utils/api'

const stateFromLocalStorage = getInfoLocalStorage()

class FormToken extends Component {

    constructor(props) {
        super(props)
        this.state = {
            step: 1,
            qt: 1,
            enderecoSolana: stateFromLocalStorage.key || '',
            error: ''
        }
    } 

    onChange = (e) => {
        this.setState({ qt: e })
    }

    onChangeSolana = (e) => {
        this.setState({ enderecoSolana: e.target.value })
    }

    onNextStep = () => {
        if(this.state.enderecoSolana === '') {
            this.setState({ error:'Este campo é obrigatório.'})
        } else if(stateFromLocalStorage.key && this.state.enderecoSolana !== stateFromLocalStorage.key) {
            this.setState({ error: 'O endereço de compra deve ser o mesmo endereço de sua Phantom Wallet conectada' })
        } else {
            this.setState({ step: 2 })
        }
    }

    goBack = () => {
        this.setState({ step: 1 })
    }

    render() {
        const { onSubmit, userid, isSubmit, success, message, tokens } = this.props
        return (
            <div className='wrapperTokenForm'>
                {this.state.step === 1 ?
                    <Step1 tokens={tokens} onChange={this.onChange} qt={this.state.qt} enderecoSolana={this.state.enderecoSolana} onChangeSolana={this.onChangeSolana} error={this.state.error} onNextStep={this.onNextStep} /> :
                    success && message !== '' ? <Sucesso /> :
                    <Step2 isSubmit={isSubmit} userid={userid} onSubmit={onSubmit} goBack={this.goBack} enderecoSolana={this.state.enderecoSolana} qt={this.state.qt} buyToken={this.buyToken} message={message} />
                }
            </div>
        )
    }
}

const mapStateToProps = state => ({
    isLoading: state.wallet_token.isLoading,
    tokens: state.wallet_token.tokens,
    userid: state.login.userid,
    isSubmit: state.wallet_token.isSubmit,
    success: state.wallet_token.success,
    message: state.wallet_token.message
})

const mapDispatchToProps = dispatch => ({
    onSubmit: (enderecoSolana, qt, userid) => {
        dispatch(buyToken(enderecoSolana, qt, userid))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(FormToken)